import { useCallback, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'

export const useSendMessage = () => {
  const [response, setResponse] = useState(null)
  const [loadingResponse, setLoadingResponse] = useState(false)
  const [errorResponse, setErrorResponse] = useState(null)
  const queryClient = useQueryClient()

  const handleSendMessage = useCallback(
    async comment => {
      setLoadingResponse(true)
      const { content, anonymus } = comment
      const client = await getApi('schools', { version: 3 })
      return client
        .post('/current-enrollment/bup-modes', {
          content,
          anonymus
        })
        .then(response => response.data)
        .then(data => {
          setResponse(data)
          setErrorResponse(null)
          queryClient.invalidateQueries({ queryKey: ['bup-modes-messages'] })
          queryClient.invalidateQueries({ queryKey: ['bup-modes-notifications'] })
        })
        .catch(error => {
          setErrorResponse(error)
          setResponse(null)
        })
        .finally(() => setLoadingResponse(false))
    },
    [setResponse, setLoadingResponse, setErrorResponse, queryClient]
  )

  return {
    response,
    loadingResponse,
    errorResponse,
    handleSendMessage
  }
}
